import vmClient from 'app/services/vmClient';
import { IText, Text } from 'app/constants/schemas/Text';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';

export interface IVocabListHeaderAttributes {
  id: EntityStringId;
  language: Language;
}

export interface IVocabListHeaderAssociations {
  titleText: IText;
  descriptionText: IText | null;
}

export interface IVocabListHeader extends IEntity {
  attributes: IVocabListHeaderAttributes;
  associations: IVocabListHeaderAssociations;
}

export const VocabListHeaderAttributes = {
  language: {
    type: Language,
    marshaller: LanguageMarshaller,
    notNull: true,
  },
};

export const VocabListHeaderAssociations = {
  titleText: {
    type: Text,
    notNull: true,
  },
  descriptionText: Text,
};

export type VocabListHeader = Entity<IVocabListHeader>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabListHeader: IEntityType<IVocabListHeader> = vmClient.defineClass({
  typeName: 'VocabListHeader',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: VocabListHeaderAttributes,
  associations: VocabListHeaderAssociations,
});
